class Register {
    constructor() {
        jQuery(() => {
            Register.prototype.initializeRegister();
        });
    }

    private initializeRegister() {
        const form = document.getElementById("register-form") as HTMLFormElement;
        const registerBtn = document.getElementById("registerBtn") as HTMLInputElement;

        form.onsubmit = (e) => {
            if (registerBtn.classList.contains("disabled")) {
                e.preventDefault();
            } else {
                registerBtn.classList.add("disabled");
            }
        };
    }
}

if (/\/Register\/?$/i.test(location.pathname)) {
    const registerWindow = window as any;
    registerWindow.Register = new Register();
}